"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastMapValue = void 0;
const last_map_entry_1 = require("./last-map-entry");
exports.lastMapValue = (map) => last_map_entry_1.lastMapEntry(map)[1];
//# sourceMappingURL=last-map-value.js.map